import {
  Col,
  Form,
  Row,
  Typography,
  VertBreadcrumb,
  VertButton,
  VertContainer,
  VertIcon,
  VertInput,
  VertInputNumberFormat,
  VertLoading,
  VertTypography,
  notification,
} from '@vertem-core/vertice-ds';
import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Disclaimer from './Components/Disclaimer';
import { useSelector } from 'react-redux';
import PersonalData from './Components/PersonalData';
import BankData from './Components/BankData';
import { formatToCPF } from 'Utils/format';
import * as yup from 'yup';
import { PremmiarEndpoint } from 'Services/Apis/clients';
import Unauthorized from './Components/Unauthorized';
import SuccessModal from './Components/SuccessModal';
import PixProvider from 'components/Checkout/CheckoutProvider';
import { CheckoutModal2FA as Pix2FaModal } from 'components/2FA/CheckoutModal2FA';
import { RightOutlined } from '@ant-design/icons';
import ynToBool from 'Utils/ynToBool';

import '../../Assets/styles/default/pages/pixPage/pixPage.less';
import { Divider, Flex } from 'antd';
import {
  calculateServiceCharge,
  getPixLimits,
  getPixLimitsTax,
} from 'Utils/calculateServiceCharge';
import { debounce } from 'lodash';
import PixKey from './Components/PixKey';
import BoxPoints from './Components/BoxPoints';

const schema = yup.object().shape({
  phone: yup
    .string()
    .required('Celular é obrigatório')
    .matches(
      /^\(\d{2}\) \d{4,5}-\d{4}$/,
      'O telefone deve seguir o formato (00) 00000-0000'
    ),
  agencyNumber: yup
    .number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .required('O número da agência é obrigatório'),
  accountNumber: yup
    .number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .required('O número da conta é obrigatório'),
  accountDigit: yup.string().nullable(),
  bank: yup.number().required('Banco é obrigatório'),
  accountType: yup.number().required('Tipo de conta é obrigatório'),

  pointsValue: yup.string().required('O valor é obrigatório'),
});

const PixPage = () => {
  const navigate = useNavigate();

  const [valueInPoints, setValueInPoints] = React.useState(0);
  const [pix2faValidation, setPix2faValidation] = React.useState(null);
  const [pixLoadingAction, setPixLoadingAction] = React.useState(false);
  const [serviceChargePix, setServiceChargePix] = React.useState(0);
  const [totalCashDecrease, setTotalCashDecrease] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [userHasAccess, setUserHasAccess] = React.useState(false);
  const [bankSelectedFullname, setBankSelectedFullName] = React.useState('');
  const [keyPixValue, setKeyPixValue] = React.useState('');
  const [isOpenSuccessModal, setIsOpenSuccesModal] = React.useState(false);
  const [conclusionOrderId, setConclusionOrderId] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false)
  const [errors, setErrors] = React.useState({
    phone: { hasError: false, msg: '' },
    agencyNumber: { hasError: false, msg: '' },
    accountNumber: { hasError: false, msg: '' },
    accountDigit: { hasError: false, msg: '' },
    bank: { hasError: false, msg: '' },
    accountType: { hasError: false, msg: '' },
    pixKey: { hasError: false, msg: '' },
    pointsValue: { hasError: false, msg: '' },
  });
  const [limits, setLimits] = React.useState({
    min: null,
    max: null,
    maxCash: null,
  });
  const [limitsTax, setLimitsTax] = React.useState({
    isPercentage: null,
    value: null,
  });

  const [form] = Form.useForm();
  const breadcrumb = [
    { title: 'Início', path: '/' },
    { title: 'Transferência Bancária', path: '/transferencia-bancaria' },
  ];

  const Participants = useSelector(({ Participants: data }) => {
    return data;
  });

  const Balance = useSelector(({ Balance: data }) => {
    return data;
  });
  const Catalog = useSelector(({ Catalog: data }) => {
    return data;
  });

  const {
    currencyConfiguration: { pointsName, decimalPlaces },
  } = Catalog;

  const { user } = useSelector((state) => state.oidc);

  const username = user.profile.username || user.profile['custom:login'];

  const config = {
    campaignId: user.profile['custom:campaign_id'],
    catalogId: user.profile['custom:catalog_id'],
    participantId: user.profile['custom:participant_id'],
    Authorization: `Bearer ${user.access_token}`,
    username: username,
  };

  const initialFormData = {
    documentNumber: formatToCPF(Participants?.cpfCnpj?.value),
    name: Participants?.name?.value,
  };

  const formatMoney = (value) => {
    return (
      parseFloat(value)
        .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        .split(',')[0] + ',00'
    );
  };

  const returnMoneyValue = (value = 0, needFormat = false) => {
    const conversionRate = Catalog.currencyConfiguration?.conversionRate
      ? Number(Catalog.currencyConfiguration?.conversionRate)
      : 1;
    const finalValue = parseInt(parseInt(value) * conversionRate);

    if (finalValue > 0) {
      return needFormat ? formatMoney(finalValue) : finalValue;
    }
    return 'R$ 0,00';
  };

  const cleanError = (field) => {
    setErrors((errors) => ({
      ...errors,
      [field]: { hasError: false, msg: '' },
    }));
  };

  const handleCalcuteServiceCharge = async (value) => {
    cleanError('pointsValue');
    const cpf = formatToCPF(Participants?.cpfCnpj?.value)?.replace(/\D/g, '');
    if (!value || parseInt(value) === 0) return;
    setIsLoading(true)
    const response = await calculateServiceCharge(value, config, cpf);
    if (!response) return;
    const { taxCash, totalCashDecrease, errors } = response.data;
    if (errors) {
      setServiceChargePix(0);
      setTotalCashDecrease(0);
      setIsLoading(false)
      if (errors.status && errors?.status === 'TRANSFER_LIMIT_EXCEEDED') {
        const msg = errors?.message;
        setErrors((errors) => ({
          ...errors,
          ['pointsValue']: { hasError: true, msg: `${msg} ${pointsName}` },
        }));
      }
      return;
    }
    setValueInPoints(value);
    setServiceChargePix(taxCash);
    setTotalCashDecrease(totalCashDecrease);
    setIsLoading(false)
  };

  const debouncedValue = debounce(handleCalcuteServiceCharge, 1600);

  function formatCashDecrease(totalCashDecrease) {
    return totalCashDecrease > 0
      ? new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }).format(totalCashDecrease)
      : returnMoneyValue(0);
  }

  function formatServiceChargePix(serviceChargePix) {
    return serviceChargePix > 0
      ? new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }).format(serviceChargePix)
      : returnMoneyValue(0);
  }

  const yupSchemaValidation = {
    async validator({ field }, value) {
      try {
        await schema.validateAt(field, { [field]: value });
        if (field === 'pointsValue') {
          const pixValue = parseInt(value);
          const minValuePix = limits?.min;

          if (value === 0) {
            throw new Error(
              `O valor mínimo para transferência é de ${limits?.min} ${pointsName}`
            );
          }

          // Validar o mínimo
          if ((pixValue < minValuePix && minValuePix > 0) || !value) {
            throw new Error(
              `O valor mínimo para transferência é de ${limits?.min} ${pointsName}`
            );
          }

          // Validar saldo insuficiente
          if (value > Balance.pointsValue) {
            throw new Error('Saldo insuficiente');
          }

          // Se passar por todas as validações, limpar o erro
          setErrors((errors) => ({
            ...errors,
            [field]: { hasError: false, msg: '' },
          }));

          setValueInPoints(value);
        } else {
          // Limpar erro para outros campos além de 'pointsValue'
          setErrors((errors) => ({
            ...errors,
            [field]: { hasError: false, msg: '' },
          }));
        }
      } catch (error) {
        // Capturar qualquer erro de validação
        setErrors((errors) => ({
          ...errors,
          [field]: { hasError: true, msg: error.message },
        }));
      }
    },
  };

  const submitHandler = (e) => {
    form.validateFields().then((values) => {
      if (Object.values(errors).some((error) => error.hasError)) {
        return notification.error({
          message: 'Preencha os campos corretamente',
        });
      }
      setLoading(true);

      const data = {
        cpf: e.documentNumber.replace(/\D/g, ''),
        name: e.name,
        pix: keyPixValue,
        bankCode: e.bank.toString(),
        accountType: e.accountType,
        agency: e.agencyNumber,
        account: e.accountNumber,
        accountDigit: e.accountDigit,
        value: e.pointsValue.toString(),
        moneyValue: returnMoneyValue(e.pointsValue, true).toString(),
        phone: e.phone.replace(/\D/g, ''),
        bankName: bankSelectedFullname,
      };

      const headers = {
        Authorization: `Bearer ${user.access_token}`,
        campaignId: user.profile['custom:campaign_id'],
        catalogId: user.profile['custom:catalog_id'],
      };

      PremmiarEndpoint(user)
        .post('/v1/pix/credit/transfer', data, { headers })
        .then((res) => {
          if (res.status === 200) {
            setConclusionOrderId(res.data.data.order.liveOrderId);
            form.resetFields();
            setIsOpenSuccesModal(true);
          } else {
            notification.error({
              message: 'Ocorreu um erro ao realizar a solicitação',
            });
          }
        })
        .catch((err) => {
          console.log(err);

          const res = err.response;

          if (
            res?.data?.errors &&
            res.data.errors?.message?.code === 'RequiresTokenValidation'
          ) {
            const { orderId, status } = res.data.errors;

            let customStatus = status == 'AUTHENTICATIONREQUIRED' && 406;

            setPix2faValidation({
              orderId,
              status: customStatus,
              data: data,
            });
            setPixLoadingAction(false);
            return;
          }

          notification.error({
            message: 'Ocorreu um erro ao realizar a solicitação',
          });
        })
        .finally(() => {
          form.resetFields();
          setValueInPoints(0);
          setLoading(false);
        });
    });
  };

  const getLimits = async () => {
    const response = await getPixLimits(config);
    if (!response) return;
    const { min, max, maxCash, hasInstallments } = response.data;
    setLimits({
      min: min,
      max: max,
      maxCash: maxCash,
      hasInstallments: hasInstallments,
    });
  };

  const getLimitsTax = async () => {
    const { isPercentage, value } = await getPixLimitsTax(config) || {};

    setLimitsTax({
      isPercentage,
      value,
    });
  };

  useEffect(() => {
    getLimits();
    getLimitsTax();

    const enabledCatalogs = process.env.REACT_APP_ALLOWED_PIX_CATALOG;
    const hasPixEnv = ynToBool(process.env.REACT_APP_HAS_PIX);
    const allowedPixUsersEnv = process.env.REACT_APP_ALLOWED_PIX_USERS;
    const participantCpfCnpj = Participants?.cpfCnpj?.value.trim();

    let hasAccesPix = false;

    const allowedPixCatalog = () => {
      if (enabledCatalogs) {
        const enabledCatalogsArray = enabledCatalogs
          .split(',')
          .map((catalog) => catalog.trim());
        return enabledCatalogsArray.includes(user.profile['custom:catalog_id']);
      }
      return false;
    };
    if (hasPixEnv && allowedPixCatalog()) {
      if (allowedPixUsersEnv) {
        const allowedUsersArray = allowedPixUsersEnv
          .split(',')
          .map((user) => user.trim());
        hasAccesPix = allowedUsersArray.includes(participantCpfCnpj);

        setUserHasAccess(hasAccesPix);
        return;
      }
      hasAccesPix = true;
      setUserHasAccess(hasAccesPix);
      return;
    }
    setUserHasAccess(hasAccesPix);
  }, [Participants?.cpfCnpj?.value]);

  const installmentLimitHasExceeded = () => {
    return limits.hasInstallments && valueInPoints > limits.max;
  };

  return !userHasAccess ? (
    <Unauthorized />
  ) : (
    <PixProvider>
      <VertContainer className="padding-x-regular padding-y-regular">
        <VertBreadcrumb
          hasBackButton={true}
          separator={<VertIcon component={RightOutlined} />}
          items={breadcrumb}
        />
        <VertTypography.Title
          level={1}
          className="margin-top-regular margin-bottom-small"
        >
          Transferência Bancária
        </VertTypography.Title>

        <Disclaimer
          limits={limits}
          limitsTax={limitsTax}
          pointsName={pointsName}
          decimalPlaces={decimalPlaces}
        />
        <Divider />
        <Form
          validateTrigger="onBlur"
          onFinish={(e) => submitHandler(e)}
          initialValues={initialFormData}
          form={form}
          className="margin-top-regular"
        >
          <Row gutter={[16, 16]} verticalSpacing="regular">
            <Col lg={8} md={8} sm={24} xs={24}>
              <div>
                <Typography.Text strong>
                  Informe o valor em {pointsName} que deseja transferir:
                </Typography.Text>
                <Form.Item
                  validateTrigger="onBlur"
                  rules={[yupSchemaValidation]}
                  name="pointsValue"
                  required
                  noStyle
                >
                  <VertInputNumberFormat
                    displayType={'input'}
                    thousandSeparator="." // Separador de milhar como ponto
                    decimalSeparator="," // Separador decimal como vírgula
                    decimalScale={decimalPlaces}
                    fixedDecimalScale={true}
                    onChange={(e) => {
                      debouncedValue(e);
                    }}
                    label={`Valor em ${pointsName} que deseja transferir`}
                    allowNegative={false}
                    isNumericString={true}
                    isPriceEditable={true}
                  />
                </Form.Item>
                {!!errors.pointsValue.hasError && (
                  <Typography.Text type="danger">
                    {errors.pointsValue.msg}
                  </Typography.Text>
                )}
              </div>
            </Col>

            <Col className="box-points-wrapper" lg={16} md={16} sm={24} xs={24}>
            {isLoading ? (
                <VertLoading className="loading-points-transfer" 
                size={'small'} 
                type='spin' 
                />
              ) : (
                <div className='box-points-content'>
                  <BoxPoints
                    title='Valor da taxa de serviço:'
                    serviceFee={formatServiceChargePix(serviceChargePix)}
                  />

                  <div className='box-points-divider'>
                    <Divider type='vertical' style={{ height: '100%' }} />
                  </div>

                  <BoxPoints
                    title='Valor a ser transferido:'
                    serviceFee={formatCashDecrease(totalCashDecrease)}
                    color='highlight'
                  />
                </div>
              )}
              {!isLoading && installmentLimitHasExceeded()  && (
                <Flex justify="end">
                  <VertTypography.Text
                    style={{
                      color: 'var(--color-detached)',
                      padding: '0 16px',
                    }}
                  >
                    A transferência do valor desejado será realizada em parcelas
                    diárias de até{' '}
                    {new Intl.NumberFormat('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    }).format(limits.maxCash)}
                  </VertTypography.Text>
                </Flex>
              )}
            </Col>
          </Row>
          <Divider />

          <Row gutter={[16, 16]}>
            <PersonalData
              inputErrors={errors?.phone?.hasError}
              form={form}
              validationSchema={[yupSchemaValidation]}
            />

            <Col
              lg={8}
              md={8}
              sm={24}
              xs={24}
              className="margin-bottom-regular"
            >
              <Form.Item
                noStyle
                rules={[yupSchemaValidation]}
                name="phone"
                required
              >
                <VertInput
                  placeholder="Celular"
                  mask="(00) 00000-0000"
                  status={
                    errors.phone.hasError
                      ? 'error'
                      : !form.isFieldTouched('phone')
                      ? 'default'
                      : 'success'
                  }
                />
              </Form.Item>
              {!!errors.phone.hasError && (
                <Typography.Text type="danger">
                  {errors.phone.msg}
                </Typography.Text>
              )}
            </Col>
          </Row>

          <BankData
            setBankFullName={setBankSelectedFullName}
            form={form}
            inputErrors={errors}
            validationSchema={[yupSchemaValidation]}
          />
          <Row gutter={[16, 16]}>
            <Col lg={8} md={8} sm={8} xs={24}>
              <Form.Item
                noStyle
                rules={[yupSchemaValidation]}
                name="agencyNumber"
                required
              >
                <VertInput
                  maxLength={5}
                  placeholder="Agência"
                  onKeyDown={(e) => {
                    if (
                      isNaN(e.key) &&
                      e.key !== 'Backspace' &&
                      e.key !== 'Delete' &&
                      e.key !== 'Tab' &&
                      e.key !== 'ArrowLeft' &&
                      e.key !== 'ArrowRight'
                    ) {
                      e.preventDefault();
                    }
                  }}
                  status={
                    errors.agencyNumber.hasError
                      ? 'error'
                      : !form.isFieldTouched('agencyNumber')
                      ? 'default'
                      : 'success'
                  }
                />
              </Form.Item>
              {!!errors.agencyNumber.hasError && (
                <Typography.Text type="danger">
                  {errors.agencyNumber.msg}
                </Typography.Text>
              )}
            </Col>
            <Col lg={12} md={12} sm={12} xs={17}>
              <Form.Item
                noStyle
                rules={[yupSchemaValidation]}
                name="accountNumber"
                required
              >
                <VertInput
                  maxLength={20}
                  placeholder="Conta"
                  onKeyDown={(e) => {
                    if (
                      isNaN(e.key) &&
                      e.key !== 'Backspace' &&
                      e.key !== 'Delete' &&
                      e.key !== 'Tab' &&
                      e.key !== 'ArrowLeft' &&
                      e.key !== 'ArrowRight'
                    ) {
                      e.preventDefault();
                    }
                  }}
                  status={
                    errors.accountNumber.hasError
                      ? 'error'
                      : !form.isFieldTouched('accountNumber')
                      ? 'default'
                      : 'success'
                  }
                />
              </Form.Item>
              {!!errors.accountNumber.hasError && (
                <Typography.Text type="danger">
                  {errors.accountNumber.msg}
                </Typography.Text>
              )}
            </Col>
            <Col lg={4} md={4} sm={4} xs={7}>
              <Form.Item
                noStyle
                rules={[yupSchemaValidation]}
                name="accountDigit"
              >
                <VertInput
                  maxLength={1}
                  placeholder="Dígito"
                  onKeyDown={(e) => {
                    if (
                      isNaN(e.key) &&
                      e.key !== 'x' &&
                      e.key !== 'X' &&
                      e.key !== 'Backspace' &&
                      e.key !== 'Delete' &&
                      e.key !== 'Tab' &&
                      e.key !== 'ArrowLeft' &&
                      e.key !== 'ArrowRight'
                    ) {
                      e.preventDefault();
                    }
                  }}
                  status={
                    errors.accountDigit.hasError
                      ? 'error'
                      : !form.isFieldTouched('accountDigit')
                      ? 'default'
                      : 'success'
                  }
                />
              </Form.Item>
              {!!errors.accountDigit.hasError && (
                <Typography.Text type="danger">
                  {errors.accountDigit.msg}
                </Typography.Text>
              )}
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="margin-top-small">
            <PixKey
              setKeyPixValue={setKeyPixValue}
              setError={setErrors}
              form={form}
              inputErrors={errors?.pixKey}
              validationSchema={[yupSchemaValidation]}
            />
          </Row>
         
          <Row gutter={[16, 16]} verticalSpacing="small">
            <Col lg={24} md={24} sm={24} xs={24}>
              <Typography.Text>
                Ao solicitar a transferência, declaro que desde já estou ciente
                de que sou responsável por informar corretamente os dados
                bancários para efetuar a transferência. Caso haja uma informação
                bancária e/ou de chave PIX incorreta, os valores transferidos
                não serão repostos pelo programa.
              </Typography.Text>
            </Col>
          </Row>
          <Row gutter={[16, 16]} justify="end">
            <Col lg={8} md={8} sm={24} xs={24}>
              <Form.Item>
                <VertButton
                  loading={loading}
                  disabled={Object.values(errors).some(
                    (error) => error.hasError
                  )}
                  type="highlight"
                  htmlType="submit"
                  block
                >
                  Solicitar Transferência
                </VertButton>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <SuccessModal
          isOpen={isOpenSuccessModal}
          closeModal={() => {
            setIsOpenSuccesModal(false);
            navigate('/my-orders');
          }}
          orderId={conclusionOrderId}
        />
      </VertContainer>

      <Pix2FaModal
        propsOrderId={pix2faValidation?.orderId}
        propsServiceName={'PIX_2FA_VALIDATION'}
        propsStatus={pix2faValidation?.status}
        purchaseData={pix2faValidation?.data}
      />
    </PixProvider>
  );
};

export default PixPage;
